import moment from 'moment';
import React, { memo, useMemo } from 'react';
import { StoryblokQuoteInformationItem } from '../../../../interfaces/StoryblokQuoteInformationItem.interface';
import { asCurrencyString } from '../../../../utils/asCurrencyString/asCurrencyString.util';

function isNumeric(value: any) {
  return !isNaN(value) && !isNaN(parseFloat(value));
}

const QuoteDetailInformationItem: React.FC<StoryblokQuoteInformationItem> = (
  props
) => {
  const valueFormatted = useMemo(() => {
    if (isNumeric(props.value)) {
      // If the value is numeric, return it as is
      return props.value;
    } else if (moment(props.value, moment.ISO_8601).isValid()) {
      // If the value is a valid date, format it
      return moment(props.value).format('DD MMM YYYY HH:mm');
    }
    // If the value is neither a valid number nor a valid date, return it as is
    return props.value;
  }, [props.value]);

  const currencyKeys = new Set([
    'buyPrice',
    'sellPrice',
    'totalPrice',
    'remortgagePrice',
    'grandTotal',
  ]);
  const nestedPropertyName = props.api_key.split('/').pop();

  return (
    <li className="w-full flex items-center justify-between text-lg text-text/body">
      <span>{props.label}:</span>
      <span className="font-bold">
        {currencyKeys.has(nestedPropertyName as string)
          ? asCurrencyString(Number(valueFormatted))
          : valueFormatted}
      </span>
    </li>
  );
};

export default memo(QuoteDetailInformationItem);
